import manage from './manage/manage';

export default [
  manage, // manage actions
];
